import {SELECT_TYPE} from './FileTypeResource';

export const archiveFileTypeResource = [
    {
        name: SELECT_TYPE, value: SELECT_TYPE
    },
    {
        name: 'arc', value: 'arc'
    },
    {
        name: 'x-freearc', value: 'x-freearc'
    },
    {
        name: 'bz', value: 'bz'
    },
    {
        name: 'x-bzip', value: 'x-bzip'
    },
    {
        name: 'bz2', value: 'bz2'
    },
    {
        name: 'x-bzip2', value: 'x-bzip2'
    },
    {
        name: 'gz', value: 'gz'
    },
    {
        name: 'gzip', value: 'gzip'
    },
    {
        name: 'jar', value: 'jar'
    },
    {
        name: 'java-archive', value: 'java-archive'
    },
    {
        name: 'tar', value: 'tar'
    },
    {
        name: 'x-tar', value: 'x-tar'
    },
    {
        name: 'zip', value: 'zip'
    },
    {
        name: '7z', value: '7z'
    },
    {
        name: 'x-7z-compressed', value: 'x-7z-compressed'
    },
    {
        name: 'rar', value: 'rar'
    },
    {
        name: 'vnd.rar', value: 'vnd.rar'
    }
];